
import { Component, OnInit } from '@angular/core';

import { NewRegistrationDialogComponent, StateFactory } from '@jct/ui';
import { RegistrationStatusService, RegistrationStatusModel, ProfileService, StudyTrackService, StudyTrack, RegistrationUserProfile, RegistrationNavigator, RegistrationProfile,VouchersService,StandingOrderService } from '@jct/api';
import { HttpStatusResult } from '@jct/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PageLayout } from '@jct/localization';

@Component({
  selector: 'registration-status.page',
  templateUrl: './registration-status-page.html',
})
export class RegistrationStatusPage implements OnInit {
  
  isNeededPaiedMikdamaVoucher: boolean = false;
  standingOrderPaymentDetails:boolean=false;
  MikdamaPaymentCode = 910;

  constructor(
    private sf: StateFactory,
    private registrationStatusService: RegistrationStatusService,
    private studyTrackService: StudyTrackService,
    private profileService: ProfileService,
    private userProfile: RegistrationUserProfile,
    public pageLayout: PageLayout,
    private vouchersService: VouchersService,
    private standingOrderService: StandingOrderService,
    private dialog: MatDialog)
  { }

  loadState = this.sf.create();
  registerState = this.sf.create();

  registrationStatus: RegistrationStatusModel;
  mainStudentStudyTrack: StudyTrack;

  get gender() {
    return this.userProfile.gender;
  }

  get isAcceptedStudent(){
    return this.userProfile.isAccepted;
  }

  private _newRegistrationDialogOpened = false;

  async ngOnInit() {
    await this.loadState.inProcess();

    const loadRegistrationResult = await this.profileService.loadRegistrationProfile();

    if (loadRegistrationResult instanceof HttpStatusResult) {
      this.loadState.failed(loadRegistrationResult);
      return;
    }

    const mainStudentStudyTrack = await this.studyTrackService.getMainStudentStudyTrackAsync();

    if (mainStudentStudyTrack instanceof HttpStatusResult) {
      this.loadState.failed(mainStudentStudyTrack);
      return;
    }

    this.mainStudentStudyTrack = mainStudentStudyTrack;

    const result = await this.registrationStatusService.getRegistrationStatusAsync();

    if (result instanceof HttpStatusResult) {
      this.loadState.failed(result);
      return;
    }

    this.registrationStatus = result;
    await this.loadState.completed();

    const paymentCodeResult = await this.vouchersService.getVouchersForPaymentAsync();

    if (paymentCodeResult instanceof HttpStatusResult) {
      this.loadState.failed(paymentCodeResult);
      return;
    }
    
    this.isNeededPaiedMikdamaVoucher = paymentCodeResult.some(voucher => 
      voucher.components.some(component => component.paymentCode === this.MikdamaPaymentCode)
    );

    await this.loadState.completed();

    const standingOrder = await this.standingOrderService.getPaymentDetailsAsync();

    if (standingOrder instanceof HttpStatusResult) {
     this.loadState.failed(standingOrder);
     return;
    }
  
    this.standingOrderPaymentDetails = standingOrder;
    await this.loadState.completed();

  }

  async register() {
    if (!this.registerState.isInProcess) {
     await this.registerState.inProcess();

      if (this._newRegistrationDialogOpened === false) {
        this._newRegistrationDialogOpened = true;

        const dialogRef = this.dialog.open(NewRegistrationDialogComponent, {
          data: { mainStudentStudyTrack: this.mainStudentStudyTrack },
          disableClose: true,
          hasBackdrop: true,
          direction: this.pageLayout.layout,
        });

        dialogRef.beforeClosed().subscribe(() => {
          this._newRegistrationDialogOpened = false;
        });
      }
      await this.registerState.completed();
    }
  }
}
